import { useEffect, useMemo } from 'react';
import { generateGuid } from '../../utils/utils';

export const TAB_ID_KEY = 'tabId';

export const useTabIdKey = () => {
  const uniqId = generateGuid();
  const guId = `tab_id-${uniqId}`;
  const id = useMemo(() => guId, []);

  useEffect(() => {
    if (typeof Storage !== 'undefined') {
      sessionStorage.setItem(TAB_ID_KEY, id);
    }
  }, [id]);

  return id;
};
